import React from 'react';
import { Home, User, Briefcase, FileText, BookOpen, Code, Phone, Newspaper } from 'lucide-react';
import { NavBar } from './ui/tubelight-navbar';

const Navbar = () => {
  const navItems = [
    { name: 'Home', url: '/', icon: Home },
    { name: 'About', url: '/about', icon: User },
    { name: 'Projects', url: '/projects', icon: Briefcase },
    { name: 'Blogs', url: '/blogs', icon: Newspaper },
    { name: 'Collections', url: '/snippets', icon: Code },
    { name: 'Publications', url: '/publications', icon: BookOpen },
    { name: 'Contact', url: '/contact', icon: Phone },
    { name: 'Resume', url: '/resume', icon: FileText }
  ];

  return <NavBar items={navItems} />;
};

export default Navbar;